import { matchRoutes } from 'react-router-dom';
import {
  initializeFaro,
  createReactRouterV6DataOptions,
  ReactIntegration,
  getWebInstrumentations,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

// Create a singleton service for Faro instance
class LoggingService {
  private static instance: ReturnType<typeof initializeFaro>;

  static getInstance(): ReturnType<typeof initializeFaro> {
    if (!this.instance) {
      if (!import.meta.env.VITE_GRAFANA_URL) {
        console.log('Grafana URL is not configured');
      }

      this.instance = initializeFaro({
        url: import.meta.env.VITE_GRAFANA_URL,
        app: {
          name: import.meta.env.VITE_GRAFANA_APP_NAME,
          version: import.meta.env.VITE_GRAFANA_APP_VERSION,
          environment: import.meta.env.VITE_GRAFANA_ENVIRONMENT,
        },
        instrumentations: [
          ...getWebInstrumentations(),
          new TracingInstrumentation(),
          new ReactIntegration({
            router: createReactRouterV6DataOptions({
              matchRoutes,
            }),
          }),
        ],
      });

      // Log initialization with environment info
      this.instance.api.pushLog([
        {
          level: 'info',
          message: 'Grafana Faro initialized',
          context: {
            environment: import.meta.env.VITE_GRAFANA_ENVIRONMENT,
            version: import.meta.env.VITE_GRAFANA_APP_VERSION,
            isDev: import.meta.env.DEV ? 'true' : 'false',
            timestamp: new Date().toISOString(),
          },
        },
      ]);
    }
    return this.instance;
  }
}

export const getFaroInstance = () => LoggingService.getInstance();

// Helper functions for consistent logging
export const logPageView = (path: string, context: Record<string, string>) => {
  const faro = getFaroInstance();
  faro.api.pushLog([
    {
      level: 'info',
      message: 'Page View',
      context: {
        path,
        ...context,
        timestamp: new Date().toISOString(),
      },
    },
  ]);
};

export const logUserAction = (action: string, context: Record<string, string>) => {
  const faro = getFaroInstance();
  faro.api.pushLog([
    {
      level: 'info',
      message: 'User Action',
      context: {
        action,
        ...context,
        timestamp: new Date().toISOString(),
      },
    },
  ]);
};
